export enum BlendEquationName {
  AddEquation = 'AddEquation',
  MaxEquation = 'MaxEquation',
  MinEquation = 'MinEquation',
  ReverseSubtractEquation = 'ReverseSubtractEquation',
  SubtractEquation = 'SubtractEquation'
}
